import React, { memo } from "react";

import { StateCallbacks } from "../../../state";
import { State, TableBlock } from "../../../types";
import { IFontInformation, Props as ContentProps } from "../types";
import { Row } from "./Row";

type Props = Readonly<{
  block: TableBlock;
  blocks: State["blocks"];
  corrections?: string;
  id: string;
  fontInformation: IFontInformation | undefined;
  onSelectBlock: StateCallbacks["onSelectBlock"];
  selected: ContentProps<TableBlock>["selected"];
  selectedCell: ContentProps<TableBlock>["selectedCell"];
  setMouseWithin: (within: boolean) => void;
  setShowReferences: (blockId: string) => void;
}>;

const TableComponent = ({
  block,
  blocks,
  id,
  fontInformation,
  onSelectBlock,
  selected,
  selectedCell,
  setMouseWithin,
  setShowReferences,
}: Props) => {
  return (
    <table
      className="table table-bordered table-sm table-striped"
      id={`support-${id}`}
      onMouseEnter={() => {
        setMouseWithin(true);
      }}
      onMouseLeave={() => {
        setMouseWithin(false);
      }}
    >
      <tbody>
        {block.cells.map((r, rowIndex) => (
          <Row
            blocks={blocks}
            key={`row-${rowIndex}`}
            fontInformation={fontInformation}
            isHeader={false}
            onSelectBlock={onSelectBlock}
            row={r}
            selectedCell={selected ? null : selectedCell}
            setShowReferences={setShowReferences}
          />
        ))}
      </tbody>
    </table>
  );
};
TableComponent.displayName = "Table";
export const Table = memo(TableComponent);
